(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["index-faq"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function () {
        if (window.jQuery) {
            $(function () {
                $('.faq-item').click(function(){
                    $(this).find('.item-desc').slideDown(300);
                    $(this).siblings().find('.item-desc').slideUp(300);
                    
                })
            });
        }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-spledid-moment"] && !Shopify.designMode) return;
  try {
    
    $(function () {
		

	});

  } catch(e) { console.error(e); }
})();
})();
